module.exports = __webpack_public_path__ + "static/media/carousel-body-two-image.ec913f41.png";